import React from 'react';
import Loading from './Loading';

interface PageSectionProps {
	title?: string;
	borderTitle?: boolean;
	borderEnd?: boolean;
	level?: number | string;
	loading?: boolean;
	children?: React.ReactNode;
}

const PageSection = ({ title, borderTitle, borderEnd, level = 4, loading, children }: PageSectionProps) => {
	const headingLevel = Number(level);

	borderTitle ??= true;
	borderEnd ??= true;

	return (
		<div className="PageSection">
			{
				title && (
					headingLevel === 1 ? <h1>{title}</h1> :
					headingLevel === 2 ? <h2>{title}</h2> :
					headingLevel === 3 ? <h3>{title}</h3> :
					headingLevel === 4 ? <h4>{title}</h4> :
					headingLevel === 5 ? <h5>{title}</h5> :
					<h6>{title}</h6>
				)
			}

			{title && borderTitle && <hr />}

			{loading ? <Loading /> : children}

			{children && borderEnd && <hr />}
		</div>
	);
}

export default PageSection;
